import { t as createFetchClient } from "./createFetchClient-DITkTV2k.js";
//#region src/fetchClient/createOpenapiFetchClient.ts
const createOpenapiFetchClient = (defaultOptions) => createFetchClient(defaultOptions);
//#endregion
export { createOpenapiFetchClient as t };

//# sourceMappingURL=createOpenapiFetchClient-wq8iGLZM.js.map